import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ParamChangeReuseStrategy extends BaseRouteReuseStrategy {
  // Angular reuses a component when only the route params change, which would carry a detail
  // page's already-loaded state onto the next record. Recreating it makes every record open
  // as a genuine first load.
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ): boolean {
    if (future.routeConfig !== current.routeConfig) {
      return false;
    }

    return this._sameParams(future, current);
  }

  private _sameParams(a: ActivatedRouteSnapshot, b: ActivatedRouteSnapshot): boolean {
    const left = a.params;
    const right = b.params;
    const keys = new Set([...Object.keys(left), ...Object.keys(right)]);

    for (const key of keys) {
      if (left[key] !== right[key]) {
        return false;
      }
    }

    return true;
  }
}
